import rill from "rill";
import set from "@rill/set";
import Calendar from "./calendar";
import EditExercise from "./edit-exercise";
import ProgramBuilder from "./program-builder";
import ProgramBuilderv1 from "./program-builder-v1";
import ProgramEditor from "./program-editor";
import ProgramOverview from "../program-library/program-overview";
import ProgramPreview from "../program-library/program-preview";
import Workout from "./workout";

const ProgramBuilderController = (app) => {
  app.at(
    "/program-builder/*",
    rill()
      .use(set("heading", ["Athlete", "My Programs"]))
      .setup(Calendar)
      .setup(EditExercise)
      .setup(ProgramBuilder)
      .setup(ProgramBuilderv1)
      .setup(ProgramEditor)
      .setup(ProgramOverview)
      .setup(ProgramPreview)
      .setup(Workout)
  );
};

export default ProgramBuilderController;
